'use client'
import styles from './BackgroundLights.module.css'
import { RefObject, useEffect, useRef, useState } from "react";

function MovingGradient({ containerRef, initialX, initialY, size }:{ containerRef: RefObject<HTMLDivElement>, initialX: number, initialY:number, size: number }) {
  const [pos, setPos] = useState({x: initialX, y: initialY });

  useEffect(() => {
    setPos({x: initialX, y: initialY})
  }, [initialX, initialY])

  useEffect(() => {
    let vx = 0.5; // velocidad horizontal
    let vy = 0.5; // velocidad vertical

    const interval = setInterval(() => {
      if (!containerRef.current) return;

      const container = containerRef.current;
      const { clientLeft, clientTop, clientWidth, clientHeight } = container;

      setPos((prev) => {
        let newX = prev.x + vx;
        let newY = prev.y + vy;

        // rebote dentro del contenedor
        if (newX > (clientLeft + clientWidth) || newX < clientLeft) vx = -vx;
        if (newY > (clientTop + clientHeight) || newY < clientLeft) vy = -vy;

        return {x: newX, y: newY};
      });
    }, 16); // ~60fps

    return () => clearInterval(interval);
  }, [containerRef, size]);



  return (
    <div
      className={styles.gradientSphere}
      style={{ left: pos.x, top: pos.y, width: size, height: size }}
    />
  );
}

export default function BackgroundLights() {

    const ref = useRef(null)

    return (
        <div className={styles.main} ref={ref}>
            <MovingGradient initialX={0} initialY={0} size={500} containerRef={ref as RefObject<HTMLDivElement>}/>
        </div>
    )
}